export default __webpack_public_path__ + "static/media/Adelalinka_Twins.59943a5a.png";